import { chainManager } from '../ChainManager';
import { checkCampaignTimeStatus } from '../../utils/contractInteraction';

/**
 * Check campaign time status via chainManager
 * Migration helper - works with current chain adapter
 */
export async function checkCampaignTimeStatusViaChainManager(
  lixiBagAddress: string,
): Promise<{
  currentTime: number;
  closingTime: number;
  timeRemaining: number;
  isExpired: boolean;
  closingTimeDate: Date;
  currentTimeDate: Date;
}> {
  const currentChain = chainManager.getCurrentChain();
  const adapter = chainManager.getCurrentAdapter();

  // If the adapter provides a native method, use it
  if (adapter?.checkCampaignTimeStatus) {
    return adapter.checkCampaignTimeStatus(lixiBagAddress);
  }

  // Fallback: BNB/EVM flow using Web3Provider
  if (currentChain === 'bnb') {
    const bnbAdapter = adapter as any;
    if (!bnbAdapter?.getConsistentProvider) {
      throw new Error('Adapter does not support checkCampaignTimeStatus');
    }

    const ethereumProvider = bnbAdapter.getConsistentProvider();
    if (!ethereumProvider) {
      throw new Error('Wallet not connected');
    }

    const { Web3Provider } = await import('@ethersproject/providers');
    const web3Provider = new Web3Provider(ethereumProvider);
    return checkCampaignTimeStatus(lixiBagAddress, web3Provider);
  }

  throw new Error(
    `checkCampaignTimeStatus not yet supported on ${currentChain} chain`,
  );
}
